import React, { useState } from "react"
import ExclamationIcon from "../../../assets/Icons/ExclamationIcon.js"
import { Button } from "../../../components/Buttons"
import PersonalLoanCard from "../../../components/PersonalLoanCard/index.js"
import Headings from "../../../components/Texts/Headings.js"

const monthlyEmi = [
  { amount: 210000, tenure: 3, emi: 70000, intrestRate: 2.3 },
  { amount: 210000, tenure: 6, emi: 35000, intrestRate: 3.5 },
  { amount: 210000, tenure: 9, emi: 25000, intrestRate: 2.3 },
]

export const LoanTenureText = ({ title, value, className = "col-span-1" }) => {
  return (
    <div className={className}>
      <p className="font-Apparat font-[500] md:font-[600] text-[12px] md:text-[16px] text-[#42495280] leading-[17px] md:leading-[19.2px] tracking-[-2%]">
        {title}
      </p>
      <p className="font-Apparat font-[600] mt-[4px] md:mt-[8px] text-[12px] md:text-[20px] leading-[13.92px] md:leading-[24px] tracking-[-2%]">
        {value}
      </p>
    </div>
  )
}

export const EMIText = ({ title, value }) => {
  return (
    <div className="col-span-1">
      {title && <p className="font-Apparat font-[600] text-[16px] text-[#42495250] leading-[18.5px] tracking-[-2%]">
        {title}
      </p>}
      <p className="font-Apparat font-[600] mt-[8px] text-[16px] leading-[18.6px] tracking-[-2%] text-[#07B9AE]">
        {value}
      </p>
    </div>
  )
}

export const LoanStatusText = ({ title, statusClass, status }) => {
  return (<div className="col-span-2">
    <p className="font-Apparat font-[600] text-[12px] md:text-[16px] text-[#42495250] leading-[12px] md:leading-[18.5px] tracking-[-2%]">
      {title}
    </p>
    <span className={`${statusClass} font-Apparat font-[600]  text-[12px] md:text-[16px] leading-[12px] md:leading-[18.5px] tracking-[-2%]  rounded-[16px] py-[6px] px-[12px]`}>
      {status}
    </span>
  </div>)
}

const ApplyLoanTenureComponent = ({ item, isSelected, selectLoanTenure }) => {
  const { amount, tenure, emi, intrestRate, id } = item
  return (
    <div
      className={`grid grid-cols-3 md:grid-cols-5 gap-[24px] md:gap-[6px] lg:gap-[18px] mt-[24px] p-[16px]   md:px-[8px] md:py-[12px] lg:p-[36px] border-dashed  border-[1.5px] rounded-[15px] cursor-pointer bg-white ${isSelected ? "border-[#07B9AE] " : "boxShadow"
        }`}
      onClick={() => selectLoanTenure(id)}
    >
      <LoanTenureText title="Amount" value={`₹ ${amount}`} className="col-span-1 order-1" />
      <LoanTenureText title="Rate" value={`2%`} className="col-span-1 order-2" />
      <LoanTenureText title="Tenure" value={`${tenure} months`} className="col-span-1 order-3" />
      <LoanTenureText title="EMI" value={`₹ ${emi}`} className="col-span-1 md:col-span-1 order-4 hidden md:block" />
      {isSelected ? <div className="col-span-1 2xl:col-span-1 flex justify-start md:justify-start items-center order-7 md:order-6 2xl:order-5">
        <Button title="Apply" variant="primary" />
      </div> : ""}

      {<LoanTenureText title="Total Interest" value={`₹ ${emi}`} className="col-span-1 md:col-span-1 order-4 2xl:order-5" />}
      {isSelected ? <div className="col-span-2 md:col-span-4 order-5 md:order-6  flex justify-center md:justify-end">
        <span className="bg-[#07B9AE1A] py-[8px] px-[10px] rounded-[25px] inline-flex items-center">
          <ExclamationIcon />
          <span className="font-[500] md:font-[600] text-[#07B9AE] text-[10px] md:text-[14px] leading-[14px] md:leading-[16.24px] tracking-[-2%] ml-[8px]">
            {" "}
            Processing Fee Excluded
          </span>
        </span>
      </div> : null}
    </div>
  )
}
const RecomendedLoanSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  return (
    <div className="mt-[60px] md:mt-[120px]">
      <Headings
        text="Recommended Loans"
        className="ml-[38px] text-[#262626]"
      />
      {/* <p className="font-filson-soft font-[700] text-[20px] md:text-[32px]  leading-[24px] md:leading-[40px] tracking-[-2%]">
        
      </p> */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-[24px] md:gap-[14px]">
        <div className="col-span-7 md:col-span-4 mt-[24px]">
          <PersonalLoanCard />
        </div>
        <div className="col-span-7 md:col-span-8 xl:col-span-8">
          {monthlyEmi?.map((item, index) => (
            <ApplyLoanTenureComponent
              key={index}
              item={{ ...item, id: index }}
              isSelected={selectedIndex == index}
              selectLoanTenure={setSelectedIndex}
            />
          ))}
        </div>
      </div>

    </div>
  )
}

export default RecomendedLoanSection
